import {
  FileImageOutlined,
  FileOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  VideoCameraOutlined
} from "@ant-design/icons"
import React from "react"

import { type LeadAttachment } from "../types/lead.types.ts"
import { attachmentExtension, isImageAttachment } from "./lead-attachments.ts"

/** The one extension→icon mapping for every surface that lists attachments,
 * so the Overview summary and the Files tab can never disagree on a type. */
const fileIconFor = (attachment: LeadAttachment) => {
  if (isImageAttachment(attachment)) return <FileImageOutlined />

  const extension = attachmentExtension(attachment)
  if (extension === "PDF") return <FilePdfOutlined />
  if (extension === "DOC" || extension === "DOCX") return <FileWordOutlined />
  if (["MP4", "MOV", "WEBM"].includes(extension ?? ""))
    return <VideoCameraOutlined />
  return <FileOutlined />
}

export { fileIconFor }
